export const GEOBLOCKED_COUNTRY_NAMES = {
  queryOnly: ['United Kingdom', 'United States of America'],
  sanctioned: [
    'Belarus',
    'Cuba',
    'Iran',
    'North Korea',
    'Russia',
    'Syria',
    'Ukraine',
  ],
};
